import { create } from 'zustand'

export interface ParamFiltersProps {
  filters: { key: string; value: string }[]
  changeFilters: (values: { key: string; value: string }[]) => void
  getFilterValue: (key: string) => string | undefined
}

export const useParamFilter = create<ParamFiltersProps>((set, get) => ({
  filters: [],
  changeFilters: (filters) => set({ filters }),
  getFilterValue: (key) => {
    const element = get().filters.find((item) => item.key === key)
    return element?.value
  },
}))
